export const gitCommit = '8ee174ac'
